/**
 * Indica se a máscara contém apenas dígitos (9) e pontuação de formatação.
 * Exemplos válidos: "999.999.999-9", "(99) 99999-9999", "9999999".
 * Exemplos inválidos: "aaa-9999", "****", "", "mascara".
 */
export const isMascaraNumerica = (mask?: string): boolean => (
  Boolean(mask) && mask !== 'mascara' && /^[9.\-\/\s()]+$/.test(mask as string)
);

/**
 * Remove caracteres que não sejam dígitos ou hífen.
 */
export const filtrarValorNumerico = (value: string): string => (
  value.replace(/[^0-9-]/g, '')
);

/**
 * Indica se a tecla deve ser permitida em campos numéricos
 * (navegação, atalhos Ctrl e dígitos).
 */
export const devePermitirTeclaNumerica = (
  event: { key: string; ctrlKey: boolean },
): boolean => {
  const { key, ctrlKey } = event;
  const isNavigationKey = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
  ].includes(key);
  const isCtrlCommand = ctrlKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase());
  const isNumericKey = /[0-9]/.test(key);
  return isNavigationKey || isCtrlCommand || isNumericKey;
};
